import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const resizeObserverLoopErr = 'ResizeObserver loop completed with undelivered notifications.';

// 1. window 에러 이벤트 핸들러 (프로덕션/개발 공통)
window.addEventListener('error', (e) => {
    if (e.message === resizeObserverLoopErr || e.message === 'ResizeObserver loop limit exceeded') {
        e.stopImmediatePropagation();
    }
});

// 2. React 개발 모드 에러 오버레이 억제 (콘솔 에러 훅킹)
const originalError = console.error;
console.error = (...args) => {
    if (
        typeof args[0] === 'string' &&
        (args[0].includes('ResizeObserver loop') || args[0].includes('ResizeObserver loop limit exceeded'))
    ) {
        return; // 이 에러 로그는 출력하지 않음
    }
    originalError(...args);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
      <BrowserRouter>
            <App />
      </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
serviceWorkerRegistration.register();
